
export const LinkToScroll = () => {
  let triggers = document.querySelectorAll('[data-smoothscroll]');
  triggers.forEach((trigger, i)=>{
    trigger.addEventListener('click', (e)=>{
      e.preventDefault();
      let targetSelector = e.target.dataset.smoothscroll;
      let elem = document.querySelector(targetSelector);
      elem.scrollIntoView({behavior: "smooth"});
    });
  });
};
